export default __webpack_public_path__ + "static/media/726.9940df1e.JPG";